<template>
  <div class="t-sidebar__greeting">
    <div class="t-sidebar__greeting-image" v-if="image"><img :src="image"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 't-sidebar-greeting',
  props: {
    image: String,
  },
};
</script>
